import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import { FaListUl, FaGraduationCap, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { Badge, ListGroup } from 'react-bootstrap';
import '../styles/card.css';

// En desarrollo usar backend local, en producción usar proxy
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4004' 
  : '';

function PendingTasksCard({ userData }) {
  const [pendingTasks, setPendingTasks] = useState({
    capacitaciones: [],
    total: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingTasks = async () => {
      // Usar IdRol en lugar de Rol
      if (!userData?.Legajo || !userData?.IdRol) {
        console.log('⚠️ PendingTasksCard: Faltan datos del usuario', { 
          Legajo: userData?.Legajo, 
          IdRol: userData?.IdRol,
          userData 
        });
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const url = `${API_URL}/api/capacitaciones/pendientes/${userData.Legajo}/${userData.IdRol}`;
        
        console.log('📥 PendingTasksCard: Obteniendo capacitaciones pendientes', { url });
        
        // Obtener capacitaciones pendientes
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          console.log('✅ PendingTasksCard: Respuesta recibida', data);
          
          setPendingTasks({
            capacitaciones: data.data || [],
            total: data.total || 0
          });
        } else {
          console.error('❌ PendingTasksCard: Error en respuesta', response.status, response.statusText);
        }
      } catch (error) {
        console.error('❌ PendingTasksCard: Error obteniendo tareas pendientes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingTasks();
  }, [userData]);

  if (loading) {
    return (
      <Card className="employee-card pending-tasks-card">
        <Card.Body>
          <Card.Title className="card-title">
            <FaListUl className="title-icon" /> Tareas Pendientes
          </Card.Title>
          <div className="text-center py-3">
            <span className="text-muted">Cargando...</span>
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="employee-card pending-tasks-card">
      <Card.Body>
        <Card.Title className="card-title">
          <FaListUl className="title-icon" /> Tareas Pendientes
        </Card.Title>
        
        <div className="pending-tasks-content">
          {/* Resumen de tareas */}
          <div className="tasks-summary mb-3">
            {pendingTasks.total > 0 ? (
              <div className="summary-item">
                <FaExclamationCircle className="text-warning me-2" size={18} />
                <span className="summary-text">
                  Tienes <Badge bg="warning" text="dark">{pendingTasks.total}</Badge> tarea{pendingTasks.total !== 1 ? 's' : ''} pendiente{pendingTasks.total !== 1 ? 's' : ''}
                </span>
              </div>
            ) : (
              <div className="summary-item">
                <FaCheckCircle className="text-success me-2" size={18} />
                <span className="summary-text text-success">
                  ¡No tienes tareas pendientes!
                </span>
              </div>
            )}
          </div>

          {/* Detalle de capacitaciones pendientes */}
          {pendingTasks.capacitaciones.length > 0 && (
            <div className="task-category">
              <div className="category-header">
                <FaGraduationCap className="me-2" style={{ color: '#0066ff' }} />
                <strong>Capacitaciones Pendientes</strong>
                <Badge bg="primary" className="ms-2">{pendingTasks.capacitaciones.length}</Badge>
              </div>
              <ListGroup variant="flush" className="mt-2">
                {pendingTasks.capacitaciones.slice(0, 5).map((capacitacion, index) => (
                  <ListGroup.Item key={index} className="pending-task-item">
                    <div className="task-item-content">
                      <span className="task-category-name">{capacitacion.categoria_nombre}</span>
                      <span className="task-module-name">{capacitacion.modulo_titulo}</span>
                    </div>
                  </ListGroup.Item>
                ))}
                {pendingTasks.capacitaciones.length > 5 && (
                  <ListGroup.Item className="text-center text-muted small">
                    Y {pendingTasks.capacitaciones.length - 5} más...
                  </ListGroup.Item>
                )}
              </ListGroup>
            </div>
          )}

          {/* Placeholder para futuros módulos */}
          {pendingTasks.total === 0 && (
            <div className="text-center text-muted py-2">
              <small>Las tareas pendientes aparecerán aquí</small>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default PendingTasksCard;
